import React from 'react';
import {Flexbox, Label} from "../index";
import {Switch as MuiSwitch} from "@mui/material";
import {checkNullStr, isBoolTrue} from "../utils/ReactUtils";
import {THEME} from "../config/FusionConfig";

import {createTheme, ThemeProvider} from '@mui/material/styles';

const theme = createTheme({
    components: {
        MuiSwitch: {
            styleOverrides: {
                root: {
                    width: 38,
                    height: 18.5,
                    padding: 0,
                    display: 'flex',
                    alignItems: 'center',
                    overflow: 'hidden',
                    borderRadius: 100,
                },
                switchBase: {
                    padding: '1px 1px 1px 1px',
                    transform: 'translateX(-.5px) translateY(-.5px)',
                    '&.Mui-checked': {
                        transform: 'translateX(19.1px) translateY(-.3px)',
                        color: '#fff',
                        '& + .MuiSwitch-track': {
                            backgroundColor: '#1890ff',
                            opacity: 1,
                            // border: 0,
                        },
                        '& .MuiSwitch-thumb': {
                            color: '#fff',
                            boxSizing: 'none',
                            boxShadow: 'none',
                        },
                    },
                },
                thumb: {
                    boxSizing: 'border-box',
                    width: 17,
                    height: 17,
                },
                track: {
                    borderRadius: '1000px',
                    backgroundColor: '#E9E9EA',
                    opacity: 1,
                    transition: 'background-color 250ms',
                },
            },
        },
    },
});

const Switch = React.memo(({
                               className = "",
                               labelClassName = "",
                               toggleClassName = "",
                               id,
                               key,
                               checked,
                               defaultChecked,
                               children,
                               style = {},
                               onChange,
                               alignAt = 'center',
                               justifyAt = 'start',
                               textAt = 'start',
                               labelStyle = {},
                               toggleStyle = {},
                               labelColor,
                               disabled,
                               outlined,
                               py = 1,
                               px = 1,
                               roundedVariant = 2,
                               variant = THEME,
                               highlightHoverVariant = 'dark',
                               selectedHighlightVariant = '',
                               highlightVariant = '',
                               ...rest
                           }) => {
    const TAG = "Switch";

    return (<>
            <ThemeProvider theme={theme}>
                <Flexbox className={`cursor-pointer text-nowrap m-0 w-100 rounded-${roundedVariant}   
                        ${isBoolTrue(disabled) ? 'disable-item' : ''} 
                        ${checkNullStr(children) ? `px-${px} py-${py}` : 'p-0'} 
                          overflow-hidden transition highlight-${highlightVariant} highlight-${highlightHoverVariant}-hover
                         ${isBoolTrue(defaultChecked) || isBoolTrue(checked) ? `highlight-${selectedHighlightVariant}` : ''}
                         ${isBoolTrue(outlined) ? `border-${selectedHighlightVariant}-dark border-${highlightHoverVariant}-hover` : ''}
                       ${className}`}
                         alignAt={alignAt}
                         justifyAt={justifyAt}
                         onClick={(e) => {
                             if (onChange) onChange(e, !isBoolTrue(checked));
                         }}>
                    <MuiSwitch
                        className={`${toggleClassName}`}
                        defaultChecked={defaultChecked}
                        checked={checked}
                        style={toggleStyle}
                        sx={{
                            // backgroundColor: 'red',
                            // height: '10px',
                        }}
                        onChange={(e) => {
                            const isChecked = isBoolTrue(e.target.checked);
                            if (onChange) onChange(e, isChecked);
                        }}
                    />

                    <Label className={`m-0 p-0 ps-1 cursor-pointer ${labelClassName}`}
                           textAt={textAt}
                           color={labelColor}
                           style={labelStyle}
                           onClick={(e) => {
                               if (onChange) onChange(e, !isBoolTrue(checked));
                           }}>
                        {children}
                    </Label>
                </Flexbox>
            </ThemeProvider>
        </>
    )
})
export default Switch;
